// BHP-1191: the one glance that has to be unambiguous.
//
// Without it, "paid" and "failed" differ by a single sentence and the colour
// of a heading — and that heading colour is the brand teal, which reads as
// decoration rather than as success. For the only question this page answers,
// that is too little.
//
// Inline SVG rather than an icon font: the page is public and should not wait
// on a webfont to tell someone whether their money arrived.
export type Mark = 'success' | 'waiting' | 'failure' | 'info';

const TONES: Record<Mark, string> = {
  success: 'bg-emerald-50 text-emerald-700',
  waiting: 'bg-amber-50 text-amber-700',
  failure: 'bg-rose-50 text-rose-700',
  info: 'bg-surface-muted text-ink-muted'
};

const PATHS: Record<Mark, string> = {
  // check
  success: 'M4 10.5l4 4 8-9',
  // clock
  waiting: 'M10 5v5l3.5 2M18 10a8 8 0 11-16 0 8 8 0 0116 0z',
  // cross
  failure: 'M5.5 5.5l9 9M14.5 5.5l-9 9',
  // i
  info: 'M10 9v5M10 6h.01M18 10a8 8 0 11-16 0 8 8 0 0116 0z'
};

export default function StatusMark({ mark }: { mark: Mark }): JSX.Element {
  return (
    <span
      className={`mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full ${TONES[mark]}`}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 20 20"
        className="h-5 w-5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d={PATHS[mark]} />
      </svg>
    </span>
  );
}
